import { z } from 'zod';
import { companySchema } from './ICompany'; // ← zod-Schema für ICompany

// Basis: IContact
export const contactSchema = z.object({
  idContact: z.number(),
  idCompany: z.number(),
  idGender: z.number(),
  idAcademicTitle: z.number(),
  FirstName: z.string(),
  LastName: z.string(),
  Birthday: z.string().nullable(),
  Birthplace: z.string().nullable(),
  Email: z.string(),
  PhoneNumber: z.string(),
  Login: z.string().optional(),
  Password: z.string().optional(),
  Postcode: z.string().optional(),
  City: z.string().optional(),
  isReceivingEmailEnabled: z.boolean(),
  viaPartner: z.literal('qonto').optional(),
});

// Erweiterung: IContactFullObject
export const contactFullObjectSchema = contactSchema.extend({
  CompanyObject: companySchema,
});

export type IContact = z.infer<typeof contactSchema>;

export type IContactFullObject = z.infer<typeof contactFullObjectSchema>;
